/** Edge instance types the API no longer accepts (#34). Legacy rows are
 *  deactivated server-side; the console offers Delete only for them —
 *  saving one back through the edit form would have to change its type. */
export const RETIRED_INSTANCE_TYPES: ReadonlySet<string> = new Set(['acre-edp'])

export function isRetiredInstanceType(type: string): boolean {
  return RETIRED_INSTANCE_TYPES.has(type)
}

/** Instance types an operator creates and edits by hand. Everything else in
 *  the list is either retired or materialized by Ostrel from a System
 *  (stream_relay, axema_forwarder): the edit form can't represent those, so
 *  saving one would silently convert its type — they get no Edit. */
export const MANUAL_INSTANCE_TYPES: ReadonlySet<string> = new Set(['axema-ws', 'http-relay'])

export function isManualInstanceType(type: string): boolean {
  return MANUAL_INSTANCE_TYPES.has(type)
}
